import { render, staticRenderFns } from "./fileDownloadMobile.vue?vue&type=template&id=656088b9&"
import script from "./fileDownloadMobile.vue?vue&type=script&lang=ts&"
export * from "./fileDownloadMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports